<template>
  <body class="body">
      <div v-if="stats" style="display: inline-flex;" class="container">
        <div style="text-align: left;">
          <div>Punctaj total: <strong>{{stats.points}}</strong> </div>
          <div>Răspunsuri corecte: <strong>{{stats.correct_answers}} din {{stats.total_answers}} întrebări</strong> </div>
          <div>Poziția în clasament: <strong>locul {{stats.position}} din {{stats.total_users}}</strong></div>
        </div>

        <div style="text-align: center;">
          <v-progress-circular
          :rotate="-90"
          size="120"
          width="8"
          :value="stats.progress / stats.total_tests * 100"
          color="#F58549"
          style="margin-top: 2%;">
          {{stats.progress}} / {{stats.total_tests}} teste
          </v-progress-circular>
        </div>

        <div style="text-align: center;">
          <button
            type="button"
            class="buton btn"
            style="margin-top: 3vh;width: fit-content;"
            @click="$router.go(-1)">
            Înapoi
          </button>
        </div>
      </div>
  </body>

</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'

export default {
  name: 'Admin',

  data:() => ({
    stats: null
  }),

  methods: {
    ...mapActions({
      sessionExpired: 'auth/sessionExpired'
    })
  },

  mounted() {
    axios.get('/general-stats').then(response => {
      this.stats = response.data
    }).catch((e) => {
      if(e.response.status == 401){
        this.sessionExpired()
        alert('Sesiunea a expirat. Te rugăm să te autentifici din nou.')
        this.$router.replace({ name: 'login' })
      }
    })
  }
}
</script>

<style scoped>
.body {
 background-color: #FBEFDA;
 display: flex;
 align-content: center;
 justify-content: center;
 flex-direction: column;
 height: 100%;
}

.container {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 80%;
  height: fit-content;
  position: relative;
  -webkit-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  text-align: center;
}

.containerstanga {
  display: flex;
  align-content: left;
  justify-content: left;
  flex-direction: column;
  text-align: left;
}
</style>
